<template>
  <v-flex xs12 row>

  	<v-layout py-3>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-text-field v-model="filter.title" label="Item Name" class="mr-3"></v-text-field>
            <v-text-field v-model="filter.code" label="Item Code" class="mr-3"></v-text-field>
            <v-autocomplete v-model="filter.warehouse" :items="warehouses" item-text="title" item-value="id" label="Warehouse" class="mr-3"></v-autocomplete>
            <search-btn @click="filterData" />
            <v-spacer></v-spacer>

          </v-card-title>
          
          <data-table
    		    :headers="$options.headers"
    		    :items="processedItems"
            :loading="processing"
    		    :title="resultTitle"
    		    :sheet-name="sheetName"
    		    hide-actions
    		    download
    		  ></data-table>

      </v-card>
      </v-flex>
    </v-layout>
    
  </v-flex>
</template>

<script>

  import DataTable from '../../components/DataTable'

  export default {
    
    components: {
      'data-table': DataTable,
    },

    data () {
      return {
        title: "Warehouse Stok Report",
        processing: false,
        items: [],
        filter: {
          title: "",
          code: "",
          warehouse: "",
        },
        warehouses: [],
      }
    },

    created () {

        let breadcrumbs = [
          {
            text: 'Dashboard',
            disabled: false,
            href: '/dashboard'
          },
          {
            text: 'Warehouses',
            disabled: false,
            href: '/warehouses'
          },
          {
            text: 'Stock Report',
            disabled: true
          }
       ]

      this.$store.commit('setBreadcrumbs', breadcrumbs)
      this.$store.commit('setPageTitle', 'Warehouse Stock')

      this.$options.headers = [
          { text: 'Item', value: 'item_name', sortable: false },
          { text: 'Code', value: 'item_code', sortable: false },
          { text: 'Warehouse', value: 'warehouse_name', sortable: false },
          { text: 'Unit', value: 'unit_name', sortable: false },
          { text: 'Parent', value: 'is_parent', sortable: false },
          { text: 'Stock QTY', value: 'stock_quantity', align: 'right', sortable: false },
          { text: 'Dead Stock', value: 'dead_stock_quantity', align: 'right', sortable: false },
        ]

      this.getAllData('warehouse')
        .then((response) => {
            this.warehouses = [...response]
        })
    },

    methods: {

      loadPage () {

      	if (!this.filter.warehouse) return

        let api_path = this.config.apis.reports.warehouse
        
        let filterArray = [ "type=inline" ]

        for (const [key, val] of Object.entries(this.filter)) {
        	if (val) {
          		filterArray.push(`${key}=${val}`)
          	}
        }

        if (filterArray.length) {
	        api_path += '?' + filterArray.join('&')
	    }
        
        this.processing = true
        this.axios.get(api_path)
          .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
              this.items = response.data.data
            }
            else{
              this.items = []
            }
          })
          .catch((error) => {
            this.processing = false
          })
      }

    },

    computed: {
    	
    	processedItems() {
    			
        	return this.items.map(item => {
    			return {
    				item_name: item.item_name,
    				item_code: item.item_code,
    				warehouse_name: item.warehouse_name,
    				unit_name: item.unit_name,
    				is_parent: item.is_parent ? 'Parent' : '-',
    				stock_quantity: item.stock_quantity,
    				dead_stock_quantity: item.dead_stock_quantity,
    			}
    		})
    		
    	},

    	sheetName() {
    		let name = ""

    		if (this.filter.warehouse) {
    			let warehouse = this.warehouses.filter(item => this.filter.warehouse === item.id )
    			if (warehouse.length) {
    				name = warehouse[0].title
    			}
    		}

    		return name
    	},

    	resultTitle () {
	      return `${this.title}_${this.sheetName || ''}_${this.today('DD-MM-YYYY')}`
	    },
	    
    },

  }
</script>
